import { FileIcon } from "components/icons";
import React from "react";
import { Card } from "semantic-ui-react";

const BaseDocumentTile = ({ title, fileName, fileExtension, onClick }) => {
  return (
    <Card className="document-tile" onClick={onClick}>
      <div className="doc-title">
        <FileIcon fileName={fileName} fileExtension={fileExtension} />
        <p className="text">{title}</p>
      </div>
    </Card>
  );
};

export default BaseDocumentTile;
